module.exports = __webpack_public_path__ + "img/u188.f4cf8c5f.png";